module.exports = __webpack_public_path__ + "static/media/honor-park.50673bee.webp";